import { IStepType } from "./IStepType"

export class SupportedTypes {
  public static voiceInput: IStepType = {
    id: "voice_input",
    name: "VoiceInput",
    visibleInMenu: true
  }

  public static playMedia: IStepType = {
    id: "play_media",
    name: "PlayMedia",
    visibleInMenu: true
  }

  public static multipleChoice: IStepType = {
    id: "multiple_choice",
    name: "MultipleChoice",
    visibleInMenu: true
  }

  public static dialogue: IStepType = {
    id: "dialogue",
    name: "Dialogue",
    visibleInMenu: true
  }

  public static tutorial: IStepType = {
    id: "tutorial",
    name: "Tutorial",
    visibleInMenu: true
  }

  public static openAnswer: IStepType = {
    id: "open_answer",
    name: "Open Answer",
    visibleInMenu: true
  }

  public static scoringResults: IStepType = {
    id: "results",
    name: "ScoringResults",
    visibleInMenu: false
  }

  public static leadForm: IStepType = {
    id: "lead_form",
    name: "Lead Form",
    visibleInMenu: false
  }

  public static all(): IStepType[] {
    return [
      this.voiceInput,
      this.playMedia,
      this.multipleChoice,
      this.scoringResults,
      this.dialogue,
      this.tutorial,
      this.openAnswer,
      this.leadForm
    ]
  }
}
